/* eslint-disable */
import * as React from 'react';
import { findDOMNode } from 'react-dom';
import { mergeStyles, IStyleConfig } from '@cian/utils';

import * as styles from './styles.css';

const COMMON_PLAYER_SETTINGS = 'autoplay=0' + '&origin=https://cian.ru' + '&rel=0'; // будут ли воспроизводиться похожие видео после завершения показа исходного видео

export interface IVideoPlayerProps {
  videoURL: string;
  videoSettings?: string;
  startSecond?: number;
  containerStyle?: IStyleConfig;
}

/*
  this is a workaround
  to add custom attrs to iframe node
  and pass react types checking
*/

export class VideoPlayer extends React.Component<IVideoPlayerProps> {
  public static defaultProps = {
    videoSettings: COMMON_PLAYER_SETTINGS,
  };

  public componentDidMount() {
    const element = findDOMNode(this.refs.player as React.ReactInstance);

    if (element) {
      (element as Element).setAttribute('type', 'text/html');
      (element as Element).setAttribute('frameborder', '0');
    }
  }

  public render() {
    const { videoURL, videoSettings, startSecond, containerStyle } = this.props;

    let videoSRC = `https://www.youtube.com/embed/${videoURL}?${videoSettings}`;

    if (startSecond) {
      videoSRC += `&start=${startSecond}`;
    }

    return (
      <div {...mergeStyles(styles['video-responsive'], containerStyle)}>
        <iframe ref="player" id="ytplayer" width="935" height="526" src={videoSRC} />
      </div>
    );
  }
}
